const angular = require('angular');

const { onBoardingComponentDefinition } = require('./onboarding-dialog.component');
const { onBoardingContentComponentDefinition } = require('./onboarding-dialog-content.component');

angular.module('wowApp.shop')
    .component('wowOnBoardingDialog', onBoardingComponentDefinition)
    .component('wowOnBoardingContentDialog', onBoardingContentComponentDefinition);




// WEBPACK FOOTER //
// ./src/shop/onboarding/index.js